@if (isDesignViewMode && type) {
<div class="design-view-wrapper" [ngClass]="[type, (isPageletSelected$ | async) ? 'pagelet-selected' : '']">
  <div class="design-view-wrapper-actions">
    @switch (type) { @case ('pagelet') { @if (pagelet$ | async; as pagelet) {
    <button
      type="button"
      (click)="triggerAction(pagelet.id, 'pageletEdit')"
      class="btn"
      title="{{ ('designview.edit.link.title' | translate) + (pagelet.displayName ? ' ' + pagelet.displayName : '') }}"
    >
      {{ pagelet.displayName ? pagelet.displayName : '(Language missing)' }}
      <fa-icon [icon]="['fas', 'pencil-alt']" />
    </button>
    <!--
            <button
              (click)="triggerAction(pagelet.id, 'pageletDelete')"
              class="btn"
              title="{{ 'designview.delete.link.title' | translate }}"
            >
              <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
            </button>
            -->
    } } @case ('slot') {
    <div class="name">{{ pagelet().slot(this.slotId()).displayName }}</div>
    <button
      type="button"
      (click)="triggerAction(this.slotId(), 'slotAdd')"
      class="btn"
      title="{{ 'designview.add.link.title' | translate }}"
    >
      <fa-icon [icon]="['fas', 'plus']" />
    </button>
    } @case ('include') {
    <div class="name">{{ include().displayName }}</div>
    <button
      type="button"
      (click)="triggerAction(include().id, 'includeAdd')"
      class="btn"
      title="{{ 'designview.add.link.title' | translate }}"
    >
      <fa-icon [icon]="['fas', 'plus']" />
    </button>
    } }
  </div>

  <!-- keep outlet if you really need it -->
  <!-- <ng-container *ngTemplateOutlet="cmsOutlet" /> -->
</div>
} @else {
<ng-content />
}
